import React, {Component} from 'react';
import cn from 'classnames'
import {connect} from'react-redux'
import injectSheet from 'react-jss'
import ImageOrVideo from "./Widgets/ImageOrVideo"
import Carousel from './Article/Carousel'
import Section from './Widgets/Section'
import SectionTitle from "./Widgets/SectionTitle"
import Link from "./Widgets/Link"
import {truncateString} from '../utils/truncateString'

const MAX_IMAGE_WIDTH = 400;
const MARGIN_RIGHT = 16;

class InstagramCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 'all'
        };
    }

    _selectTab = (value) => {
        this.setState({selectedTab: value});
    }

    render() {
        const {classes, slice} = this.props;
        const {images, heading, cta_text, cta_link} = slice;
        const {selectedTab} = this.state;

        if (!images) return null;

        return (
            <Section className={classes.root}>
                {heading && (<SectionTitle text={heading} />)}
                <div className={classes.imageContainer}>
                    <Carousel 
                        key={selectedTab}
                        prevNextContainer={props => (
                            <div className={classes.carouselPrevNextContainer}>
                                <div className={classes.tabs}>
                                    <div className={cn(classes.tabsContainer, selectedTab)}>
                                        <a onClick={() => this._selectTab('all')}>All</a>
                                        <a onClick={() => this._selectTab('women')}>Women</a>
                                        <a onClick={() => this._selectTab('men')}>Men</a>
                                    </div>
                                </div>
                                <div>{props.children}</div>
                            </div>
                        )}
                        prevNextAbove={true}
                        showCount={false}
                        classNames={classes}
                        items={images.filter(x => selectedTab === 'all' ? x : x.gender === selectedTab).map((i, index) => (
                            <div key={index} className={classes.flikityCell}>
                                <a href={i.permalink} target="_blank">
                                    <ImageOrVideo className={classes.image} images={i} sizes={`min-width: ${MAX_IMAGE_WIDTH}px ${MAX_IMAGE_WIDTH}px, 100vw`} />
                                </a>
                                <p className={classes.caption}>{truncateString(i.caption,140)}</p>
                            </div>
                        )
                    )}/>
                    {cta_link && cta_link.url && <div className={classes.cta}><Link link={{...cta_link, target: 'blank'}}>{cta_text}</Link></div>}
                </div>
            </Section>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedTab: state.selectedTab
    }
}

export default injectSheet((theme) => ({
    root: {
        marginBottom: 0
    },
    container: {
        position: 'relative',
        padding: [theme.spacing.normal, 0],
        textAlign: 'center',
        minHeight: 300
    },
    title: {
        minWidth: 30
    },
    imageContainer: {
        width: '100%'
    },
    carouselPrevNextContainer: {
        borderBottom: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: 20
    },
    prevNextContainer: {
        margin: 0
    },
    caption: {
        paddingTop: 10,
        fontSize: 14,
        lineHeight: '22px',
        marginBottom: 0
    },
    cta: {
        textAlign: 'center',
        marginBottom: theme.spacing.large
    },
    flikityCell: {
        marginRight: MARGIN_RIGHT,
        width: `calc((100% - ${MARGIN_RIGHT * 1}px)/2)`,
        [theme.breakpoint("tablet")]: {
            width: `calc((100% - ${MARGIN_RIGHT * 2}px)/3)`,
        },
        [theme.breakpoint("laptop")]: {
            width: `calc((100% - ${MARGIN_RIGHT * 3}px)/4)`,
        },
        '&.women.menCard': {
            display: 'none'
        },
        '&.men.womenCard': {
            display: 'none'
        }
    },
    tabs: {
        height: 36,
        lineHeight: '35px',
        background: '0 0',
        display: 'block',
        "& a": {
            color: theme.colors.black,
            display: 'inline-block',
            padding: '8px 13px',
            verticalAlign: 'middle',
            textTransform: 'uppercase',
            lineHeight: theme.convertFromIconicRemValue(1),
            fontFamily: "ProximaNovaBold",
            fontWeight: 'bold',
            fontSize: '11px',
            '&:hover': {
                textDecoration: 'none'
            },
            [theme.breakpoint('tablet')]: {
                fontSize: '13px',
            },
        }
    },
    tabsContainer: {
        position: 'relative',
        display: 'inline-block',
        textAlign: 'center',
        userSelect: 'none',
        "&:before": {
            height: theme.convertFromIconicRemValue(0.1875),
            position: 'absolute',
            bottom: theme.convertFromIconicRemValue(-0.0625),
            left: 0,
            content: '""',
            background: theme.colors.primary,
            transition: 'all .3s ease-in-out'
        },
        "&.all:before": {
            left: 0,
            width: '27%',
        },
        "&.women:before": {
            left: '27%',
            width: '42%',
        },
        "&.men:before": {
            left: '69%',
            width: '31%',
        }
    },
    selectedTab: {
    }
}))(connect(mapStateToProps)(InstagramCarousel))




// WEBPACK FOOTER //
// ./src/components/InstagramCarousel.js